import { defineMessages } from '@jutro/locale';

export default defineMessages({
    bundleTotal: {
        id: 'agent.directives.ml-bundle-widgit.Bundle Total',
        defaultMessage: 'Bundle Total'
    },
    editBundle: {
        id: 'agent.directives.ml-bundle-widgit.Edit Bundle',
        defaultMessage: 'Edit Bundle'
    },
    somethingWentWrong: {
        id: 'ml.agent.common.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    }
})